const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class ThreeCta extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.classList.contains('sec-ThreeCta-stack')) return

    this.carousel = this.setupCarousel()
  }

  getSpacing () {
    const gap = this.dataset.gap

    if (gap === 'large') return 16
    return 4
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    const spacing = this.getSpacing()

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing,
        },
        breakpoints: {
          '(min-width: 901px)': {
            disabled: true,
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('three-cta')) {
  customElements.define('three-cta', ThreeCta)
}
